// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Styled, { getIconBackgroundColor, getIconColor, getTheme, getTextColor } from './MapLayerButton.styles';

export default class MapLayerButton extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    selected: PropTypes.bool
  };

  static defaultProps = {
    selected: false
  };

  render() {
    const { selected, icon, label, ...otherProps } = this.props;

    return (
      <ThemeProvider theme={{ type: getTheme(selected) }}>
        <Styled.Button pill selected={selected} {...otherProps}>
          <Styled.Icon
            selectedIcon={icon}
            mapLayer
            width="20px"
            iconColor={getIconColor(selected)}
            backgroundColor={getIconBackgroundColor(selected)}
          />
          <Styled.Copy tagName="div" noMargins color={getTextColor(selected)}>
            {label}
          </Styled.Copy>
        </Styled.Button>
      </ThemeProvider>
    );
  }
}
